/**
 * Returns all section ids from the loaded case plan sections list.
 */
export const getAllSectionIds = (sections = []) =>
  sections.map((section) => section.id).filter(Boolean);

/**
 * Resolves display names for widgets on a section (from mapped widget props).
 */
export const getWidgetNames = (section) =>
  (section?.widgets ?? [])
    .map((widget) => widget?.props?.title)
    .filter(Boolean);

/**
 * Toggles a section id in the selected set.
 */
export const toggleId = (selectedIds, sectionId) => {
  if (selectedIds.includes(sectionId)) {
    return selectedIds.filter((id) => id !== sectionId);
  }

  return [...selectedIds, sectionId];
};

/**
 * Whether every section id is currently selected.
 */
export const areAllSectionsSelected = (selectedIds, sections = []) => {
  const allIds = getAllSectionIds(sections);
  if (allIds.length === 0) {
    return false;
  }

  return allIds.every((id) => selectedIds.includes(id));
};
